import axiosInstance from "./axiosInstance";

export const LoginApi = async (data) => {
  const API_URL = "/login";
  return await axiosInstance.post(API_URL, data);
};

export const RegisterCompanyApi = async (data) => {
  const API_URL = "/signup";
  return await axiosInstance.post(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const Verifyotp = async (data) => {
  const API_URL = "/verify-otp";
  return await axiosInstance.post(API_URL, data);
};

export const AddEmployeeApi = async (data) => {
  const API_URL = "/api/v1/employees/add";
  return await axiosInstance.post(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fetchEmployeeApi = async (id, data) => {
  const API_URL = `/api/v1/organization/employees?organization_id=${id}`;
  return await axiosInstance.get(API_URL, data);
};

export const fetchCameraTypeApi = async () => {
  const API_URL = "/camera-types";
  return await axiosInstance.get(API_URL);
};

export const AddCameraApi = async (data) => {
  const API_URL = "/camera-details";
  return await axiosInstance.post(API_URL, data);
};
export const upadteCameraApi = async (data, id) => {
  const API_URL = `/camera-details/${id}`;
  return await axiosInstance.put(API_URL, data);
};

export const fetchCameralistingApi = async (
  page = 1,
  limit = 6,
  search,
  user_id,
  org_id
) => {
  console.log(user_id, org_id, "qwert");
  if (search) {
    const API_URL = `/camera-details?user_id=${user_id}&organization_id=${org_id}&page=${page}&limit=${limit}&camera_name=${search}`;
    return await axiosInstance.get(API_URL);
  } else {
    const API_URL = `/camera-details?user_id=${user_id}&organization_id=${org_id}&page=${page}&limit=${limit}`;
    return await axiosInstance.get(API_URL);
  }
};

export const fetchCameralistingEventApi = async (
  page = 1,
  limit = 6,
  search
) => {
  if (search) {
    const API_URL = `/cameras?page=${page}&limit=${limit}&camera_name=${search}`;
    return await axiosInstance.get(API_URL);
  } else {
    const API_URL = `/cameras?page=${page}&limit=${limit}`;
    return await axiosInstance.get(API_URL);
  }
};

export const fetchCameralistingApiId = async (id, user_id, org_id) => {
  const API_URL = `/camera-details/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const deleteCameralistingApiId = async (id, user_id, org_id) => {
  const API_URL = `/camera-details/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const getallUsecaseOnCamera = async (id, start_date, end_date) => {
  const API_URL = `/camera-details-usecase/${id}?start_date=${start_date}&end_date=${end_date}`;
  return await axiosInstance.get(API_URL);
};

export const fetchCameragrouplistingApi = async (search, user_id, org_id) => {
  const API_URL = `/camera-groups?user_id=${user_id}&organization_id=${org_id}&camera_group_name=${search}`;
  return await axiosInstance.get(API_URL);
};

export const DeleteCameraGroupApi = async (id, user_id, org_id) => {
  const API_URL = `/camera-groups/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const fetchCameraApi = async (id, data) => {
  const API_URL = `/api/v1/organization/devices?organization_id=${id}`;
  return await axiosInstance.get(API_URL, data);
};

export const UpdateEmployeeApi = async (data) => {
  const API_URL = "/api/v1/employees";
  return await axiosInstance.put(API_URL, data);
};

export const CreateCameraGroupApi = async (data) => {
  const API_URL = "/camera-groups";
  return await axiosInstance.post(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const AddCourseApi = async (data) => {
  const API_URL = `/courses`;
  return await axiosInstance.post(API_URL, data);
};

export const UpdateCourseApi = async (data, id) => {
  const API_URL = `/courses/${id}`;
  return await axiosInstance.put(API_URL, data);
};
export const deleteCourseApi = async (id, user_id, org_id) => {
  const API_URL = `/courses/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const CourseListApi = async (search, user_id, org_id) => {
  let API_URL;
  if (search)
    API_URL = `/courses?course_name=${search}&user_id=${user_id}&organization_id=${org_id}`;
  else API_URL = `/courses?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const SemesterListApiByCourse = async (id) => {
  const API_URL = `/semesters/${id}`;
  return await axiosInstance.get(API_URL);
};

export const SubjectListApiBySemester = async (id) => {
  const API_URL = `subjects/${id}`;
  return await axiosInstance.get(API_URL);
};

export const AddProfessorApi = async (data) => {
  const API_URL = `/professors`;
  return await axiosInstance.post(API_URL, data);
};

export const ProfessorListApi = async () => {
  const API_URL = `/professors`;
  return await axiosInstance.get(API_URL);
};

export const ProfessorDetailApi = async (id) => {
  const API_URL = `/professors/${id}`;
  return await axiosInstance.get(API_URL);
};
export const UpdateProfessorApi = async (data, id) => {
  const API_URL = `/professors/${id}`;
  return await axiosInstance.put(API_URL, data);
};

export const DeleteProfessorApi = async (id) => {
  const API_URL = `/professors/${id}`;
  return await axiosInstance.delete(API_URL);
};

export const AddCameraTypeApi = async (data) => {
  const API_URL = `/devices`;
  return await axiosInstance.post(API_URL, data);
};

export const UpdateCameraTypeApi = async (id, user_id, org_id, data) => {
  const API_URL = `/devices/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.put(API_URL, data);
};

export const CameraTypeListingApi = async (search, user_id, org_id) => {
  const API_URL = `/devices?device_name=${search}&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};
export const DeleteCameraTypeListingApi = async (id, user_id, org_id) => {
  const API_URL = `/devices/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const GetDetailByCameraType = async (id, user_id, org_id) => {
  const API_URL = `/devices?camera_type_id=${id}&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const AddStudentApi = async (data) => {
  const API_URL = `/students`;
  return await axiosInstance.post(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const GetBranch = async (user_id, org_id) => {
  const API_URL = `/branches?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const GetStudents = async (
  page = 1,
  limit = 10,
  search,
  user_id,
  org_id
) => {
  let API_URL;
  if (search) {
    API_URL = `/students?page=${page}&limit=${limit}&student_name=${search}&user_id=${user_id}&organization_id=${org_id}`;
  } else {
    API_URL = `/students?page=${page}&limit=${limit}&user_id=${user_id}&organization_id=${org_id}`;
  }

  return await axiosInstance.get(API_URL);
};

export const GetRoomlist = async () => {
  const API_URL = `/rooms`;
  return await axiosInstance.get(API_URL);
};

export const AddScheduleApi = async (data) => {
  const API_URL = `/schedules`;
  return await axiosInstance.post(API_URL, data);
};

export const ScheduleListApi = async () => {
  const API_URL = `/schedules`;
  return await axiosInstance.get(API_URL);
};
export const ScheduleListByIdApi = async (id) => {
  const API_URL = `/schedules/${id}`;
  return await axiosInstance.get(API_URL);
};

export const UpdateScheduleListApi = async (data, id) => {
  const API_URL = `/schedules/${id}`;
  return await axiosInstance.put(API_URL, data);
};

export const DeleteScheduleApi = async (id) => {
  const API_URL = `/schedules/${id}`;
  return await axiosInstance.delete(API_URL);
};

export const AddEmployedata = async (data) => {
  const API_URL = `/employees`;
  return await axiosInstance.post(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const UpdateEmployedata = async (data, id) => {
  const API_URL = `/employees/${id}`;
  return await axiosInstance.put(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteEmployee = async (id, user_id, org_id) => {
  const API_URL = `/employees/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const EmployeeListApi = async (
  page = 1,
  limit = 6,
  search,
  user_id,
  org_id
) => {
  const API_URL = `/employees?page=${page}&limit=${limit}&employee_name=${search}&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};
export const GetEmployeeDetailApi = async (id, user_id, org_id) => {
  const API_URL = `/employee-details?employee_id=${id}&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};
export const EmployeeeStatusChange = async (data, user_id, org_id) => {
  const API_URL = `/blockEmployee?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.put(API_URL, data);
};
// export const UseCaseListingApi = async () => {
//   const API_URL = `/usecases`;
//   return await axiosInstance.get(API_URL);
// };

export const AddEventApi = async (data) => {
  const API_URL = `/usecase-mapping`;
  return await axiosInstance.post(API_URL, data);
};

export const EventApi = async (search, user_id, org_id) => {
  let API_URL;
  if (search)
    API_URL = `/usecase-mapping?usecase_name=${search}&user_id=${user_id}&organization_id=${org_id}`;
  else
    API_URL = `/usecase-mapping?user_id=${user_id}&organization_id=${org_id}`;

  return await axiosInstance.get(API_URL);
};

export const EventListApi = async (start_date, end_date) => {
  let API_URL;
  if (start_date && end_date)
    API_URL = `/event-notifications?start_date=${start_date}&end_date=${end_date}`;
  else API_URL = `/event-notifications`;
  return await axiosInstance.get(API_URL);
};

export const EventListUseCaseApi = async (user_id, org_id) => {
  const API_URL = `/event?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

// export const CheckinCheckoutapi = async () => {
//   const API_URL = `/checkin-checkout`;
//   return await axiosInstance.get(API_URL);
// };

// export const GetCheckinCheckoutapi = async () => {
//   const API_URL = `/checkin-checkout`;
//   return await axiosInstance.get(API_URL);
// };

export const GetCheckinCheckoutapi = async (
  date,
  name,
  page = 1,
  limit = 10
) => {
  const params = new URLSearchParams();

  if (date) params.append("date", date);
  if (name) params.append("employee_name", name);
  params.append("page", page);
  params.append("limit", limit);

  const API_URL = `/checkin-checkout?${params.toString()}`;
  // const API_URL = `/unique-checkin-checkout?${params.toString()}`;
  return await axiosInstance.get(API_URL);
};

export const CheckIncheckOutCameraApi = async (user_id, org_id) => {
  const API_URL = `/usecase-mapping?usecase_id=68e4f28dbc3be20966230ada,68e4f27994468c2ae981e741&&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const GetDashboardCheckinCheckoutapi = async (
  start_date,
  end_date,
  name,
  page = 1,
  limit = 10
) => {
  const params = new URLSearchParams();

  if (start_date) params.append("start_date", start_date);
  if (end_date) params.append("end_date", end_date);
  if (name) params.append("employee_name", name);
  params.append("page", page);
  params.append("limit", limit);

  const API_URL = `/dashboard-checkin-checkout?${params.toString()}`;
  // const API_URL = `/unique-checkin-checkout?${params.toString()}`;
  return await axiosInstance.get(API_URL);
};

export const GetUniqueCheckinCheckoutapi = async (
  date,
  name,
  page = 1,
  limit = 10
) => {
  const params = new URLSearchParams();

  if (date) params.append("date", date);
  if (name) params.append("employee_name", name);
  params.append("page", page);
  params.append("limit", limit);

  // const API_URL = `/checkin-checkout?${params.toString()}`;
  const API_URL = `/unique-checkin-checkout?${params.toString()}`;
  return await axiosInstance.get(API_URL);
};

export const GetCheckinCheckoutapiByEmployeeId = async (id) => {
  const API_URL = `/employee-checkin-checkout?employee_id=${id}`;
  return await axiosInstance.get(API_URL);
};

export const GetAttendenceApi = async (date, course_id, room_id, modeType) => {
  let query = "";

  if (date) query += `date=${date}`;
  if (course_id) query += `&course_id=${course_id}`;
  if (room_id) query += `&schedule_id=${room_id}`;
  if (modeType) query += `&mode_type=${modeType}`;

  const API_URL = `/attendance-logs-by-course?${query}`;

  return await axiosInstance.get(API_URL);
};

export const GetAttendenceEventDetail = async (
  page = 1,
  limit = 6,
  start_date,
  end_date
) => {
  const API_URL = `/attendance-logs-dashboard?page=${page}&limit=${limit}&start_date=${start_date}&end_date=${end_date}`;
  return await axiosInstance.get(API_URL);
};

export const GetDoorAttandenceApi = async () => {
  const API_URL = `/door-logs`;
  return await axiosInstance.get(API_URL);
};

export const getAllDeviceControllers = async (search, user_id, org_id) => {
  const API_URL = `/device-controllers?device_name=${search}&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const getOneDeviceControllers = async (id, user_id, org_id) => {
  const API_URL = `/device-controllers-details?device_id=${id}&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const createDeviceControllers = async (data) => {
  const API_URL = `/device-controllers`;
  return await axiosInstance.post(API_URL, data);
};

export const updateDeviceControllers = async (data) => {
  const API_URL = `/device-controllers`;
  return await axiosInstance.put(API_URL, data);
};

export const deleteDeviceControllers = async (id, user_id, org_id) => {
  const API_URL = `/device-controllers/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const getStudentData = async (id) => {
  const API_URL = `/students/${id}`;
  return await axiosInstance.get(API_URL);
};

export const updateStudentdata = async (data) => {
  const API_URL = `/students`;
  return await axiosInstance.put(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteStudentData = async (id, user_id, org_id) => {
  const API_URL = `/students/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const StatusChangeStudent = async (data) => {
  const API_URL = `/blockStudent`;
  return await axiosInstance.put(API_URL, data);
};

export const getEventDataById = async (id) => {
  const API_URL = `/usecase-mapping/${id}`;
  return await axiosInstance.get(API_URL);
};

export const updateEventApi = async (data, id) => {
  const API_URL = `/usecase-mapping/${id}`;
  return await axiosInstance.put(API_URL, data);
};

export const deleteEventData = async (id) => {
  const API_URL = `/usecase-mapping/${id}`;
  return await axiosInstance.delete(API_URL);
};

export const StatusChangeUseCaseMappping = async (id, data) => {
  const API_URL = `/usecase-mapping/${id}`;
  return await axiosInstance.put(API_URL, data);
};

export const getCourseData = async (id, user_id, org_id) => {
  const API_URL = `/course-details?course_id=${id}&user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const getRoomDettails = async () => {
  const API_URL = `/rooms`;
  return await axiosInstance.get(API_URL);
};

export const deleteRoomData = async (id) => {
  const API_URL = `/rooms/${id}`;
  return await axiosInstance.delete(API_URL);
};

export const AddRoomApi = async (data) => {
  const API_URL = `/rooms`;
  return await axiosInstance.post(API_URL, data);
};

export const updateRoomApi = async (data, id) => {
  const API_URL = `/rooms/${id}`;
  return await axiosInstance.put(API_URL, data);
};

export const getRoomDataById = async (id) => {
  const API_URL = `/rooms/${id}`;
  return await axiosInstance.get(API_URL);
};

export const GetDeviceById = async (id) => {
  const API_URL = `/devices/${id}`;
  return await axiosInstance.get(API_URL);
};

export const CameraAccess = async () => {
  const API_URL = "/cameraaccess";
  return await axiosInstance.get(API_URL);
};

export const UseCaseMappingAttendence = async () => {
  const API_URL = "/usecases-camera?usecase_name=attendence";
  return await axiosInstance.get(API_URL);
};

export const getAllUseCaseVideos = async () => {
  const API_URL = `/usecase-videos`;
  return await axiosInstance.get(API_URL);
};

export const getAllLectureAnalysis = async () => {
  const API_URL = `/lecture-analyses`;
  return await axiosInstance.get(API_URL);
};

export const getAllLectureConverter = async () => {
  const API_URL = `/audio-transcripts`;
  return await axiosInstance.get(API_URL);
};

export const getnumberPlates = async () => {
  const API_URL = `/number-plates`;
  return await axiosInstance.get(API_URL);
};

export const UseCaseNumberPlateAttendence = async () => {
  const API_URL = "/usecases-camera?usecase_name=NumberPLateDetection";
  return await axiosInstance.get(API_URL);
};

export const getAlertListApi = async () => {
  const API_URL = `/alert-types`;
  return await axiosInstance.get(API_URL);
};

export const getActionsListApi = async () => {
  const API_URL = `/action-types`;
  return await axiosInstance.get(API_URL);
};

export const setEventRecord = async (data) => {
  const API_URL = `/event-records`;
  return await axiosInstance.post(API_URL, data);
};

export const GetQueueEventDetail = async () => {
  const API_URL = `/queue-waiting-logs`;
  return await axiosInstance.get(API_URL);
};

// rama-logs
export const GetRamaLogs = async () => {
  const API_URL = `/rama-logs`;
  return await axiosInstance.get(API_URL);
};

//rama-mess-log
export const GetRamaMessLogs = async () => {
  const API_URL = `/rama-mess-logs`;
  return await axiosInstance.get(API_URL);
};

export const GetExistingEvent = async (id) => {
  const API_URL = `/camera-event-records?camera_id=${id}`;
  return await axiosInstance.get(API_URL);
};

export const UpdateEventCamera = async (data) => {
  const API_URL = `/event-records`;
  return await axiosInstance.put(API_URL, data);
};

export const GetQueuewaitingEvent = async (id) => {
  const API_URL = `/event?usecase_id=${id}`;
  return await axiosInstance.get(API_URL);
};

export const GetQueueEventlogs = async (id) => {
  const API_URL = `/queue-waiting-logs?camera_id=${id}`;
  return await axiosInstance.get(API_URL);
};
//queue-waiting-logs
export const GetQueueLogApi = async (id) => {
  const API_URL = `/queue-waiting-logs?camera_id=${id}`;
  return await axiosInstance.get(API_URL);
};

export const GetSeatMonitioringApi = async (id) => {
  const API_URL = `/seat-logs?camera_id=${id}`;
  return await axiosInstance.get(API_URL);
};

export const GetNumberPlatEventDetail = async (start_date, end_date) => {
  const API_URL = `/number-plates-dashboard?start_date=${start_date}&end_date=${end_date}`;
  return await axiosInstance.get(API_URL);
};

export const GetDoorEventDetail = async (
  page = 1,
  limit = 10,
  start_date,
  end_date
) => {
  const API_URL = `/door-logs-dashboard?page=${page}&limit=${limit}&start_date=${start_date}&end_date=${end_date}`;
  return await axiosInstance.get(API_URL);
};

export const GetQueueWaitEventDetail = async (
  page = 1,
  limit = 10,
  start_date,
  end_date
) => {
  const API_URL = `/queue-waiting-logs-dashboard?page=${page}&limit=${limit}&start_date=${start_date}&end_date=${end_date}`;
  return await axiosInstance.get(API_URL);
};

export const GetFireDetectionlogs = async () => {
  const API_URL = `/fire-detection-logs`;
  return await axiosInstance.get(API_URL);
};

export const GetRamaMessDashbordApi = async (start_date, end_date) => {
  const API_URL = `/rama-mess-logs-dashboard?start_date=${start_date}&end_date=${end_date}`;
  return await axiosInstance.get(API_URL);
};

//rama-logs-dashboard
export const GetRamaDashbordApi = async (start_date, end_date) => {
  const API_URL = `/rama-logs-dashboard?start_date=${start_date}&end_date=${end_date}`;
  return await axiosInstance.get(API_URL);
};

export const fetchInvitedUsers = async (user_id, org_id) => {
  const API_URL = `/invite?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.get(API_URL);
};

export const sendInvitedUsers = async (data) => {
  const API_URL = `/invite`;
  return await axiosInstance.post(API_URL, data);
};

export const getInviteDetails = async (data) => {
  const API_URL = `/invite-signup`;
  return await axiosInstance.post(API_URL, data);
};

export const fetchTeamMmebers = async (id) => {
  const API_URL = `/team-members/${id}`;
  return await axiosInstance.get(API_URL);
};

///event
export const GetEventDetail = async (data) => {
  const API_URL = `/event/${data}`;
  return await axiosInstance.get(API_URL);
};

export const CreateNewEvent = async (data) => {
  const API_URL = `/event`;
  return await axiosInstance.post(API_URL, data);
};

export const RamaStudentsListApi = async (page = 1, limit = 10, search) => {
  const API_URL = `/rama-students?page=${page}&limit=${limit}&student_name=${search}`;
  return await axiosInstance.get(API_URL);
};

export const AddRamaStudentApi = async (data) => {
  const API_URL = `/rama-students`;
  return await axiosInstance.post(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UpdateRamaStudentdata = async (data) => {
  const API_URL = `/update-rama-students`;
  return await axiosInstance.put(API_URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const GetRamaStudentDetailApi = async (id) => {
  const API_URL = `/rama-students/${id}`;
  return await axiosInstance.get(API_URL);
};

export const DeleteRamaStudentDetailApi = async (id) => {
  const API_URL = `/delete-rama-students/${id}`;
  return await axiosInstance.delete(API_URL);
};

export const ExportData = async (data) => {
  const API_URL = `/logs-export?date=${data}`;
  return await axiosInstance.get(API_URL);
};

export const RamaStudentStatusChange = async (data) => {
  const API_URL = `/block-rama-Student`;
  return await axiosInstance.put(API_URL, data);
};

export const UsecaseEvnetById = async (data) => {
  const API_URL = `/event?usecase_id=${data}`;
  return await axiosInstance.get(API_URL, data);
};

export const deleteEventApi = async (id) => {
  const API_URL = `/event/${id}`;
  return await axiosInstance.delete(API_URL);
};

export const CameraEvnetById = async (data) => {
  const API_URL = `/event?camera_id=${data}`;
  return await axiosInstance.get(API_URL, data);
};

export const TeamMemberStatusChange = async (id, data) => {
  const API_URL = `/user-disable/${id}`;
  return await axiosInstance.post(API_URL, data);
};

export const UpdateTeamMember = async (data) => {
  const API_URL = `/user-update`;
  return await axiosInstance.post(API_URL, data);
};

export const AddUsecaseApi = async (data) => {
  const API_URL = `/usecases`;
  return await axiosInstance.post(API_URL, data);
};

export const UpdateUsecaseApi = async (id, data) => {
  const API_URL = `/usecase-update/${id}`;
  return await axiosInstance.put(API_URL, data);
};

export const UseCaseeventListApi = async (id, user_id, org_id) => {
  let API_URL;
  if (id) API_URL = `/usecases/${id}`;
  else API_URL = `/usecases?user_id=${user_id}&organization_id=${org_id}`;

  return await axiosInstance.get(API_URL);
};

export const deleteUsecaseId = async (id, user_id, org_id) => {
  const API_URL = `/usecases/${id}?user_id=${user_id}&organization_id=${org_id}`;
  return await axiosInstance.delete(API_URL);
};

export const UpdateUserInvite = async (id, data) => {
  const API_URL = `/invite/${id}`;
  return await axiosInstance.put(API_URL, data);
};
